/**
 * 콤보상품 정보
 */
export interface comboProduct {
    /** 비대면콤보유형코드
     * "01"    입출식_스마트뱅킹
     * "02"    입출식_적립식_스마트뱅킹
     * "03"    입출식_스마트뱅킹_체크카드
     * @type {string}
     */
    nofcCmbTcd?: string

    /** 비대면콤보상품타입
     * "01"    입적스
     * "02"    입스체
     * @type {string}
     */
    nofcCmbType?: string

    /** 비대면콤보진행여부
     * 이어가기에서 조회 후 사용
     * @type {string}
     */
    nofcCmbPgrsYn?: string

    /** 비대면실명확인진행상태코드
     * @type {string}
     */
    nofcRlncPgrsScd02: string

    /** 비대면채널상품분류그룹코드
     * @type {string}
     */
    nfchPrcfGrpCd?: string

    /** 비대면채널상품분류그룹코드명
     * @type {string}
     */
    nfchPrcfGrpCdNm?: string

    /** 관련상품라인코드
     * @type {string}
     */
    rltdPdlnCd: string

    /** 관련상품그룹코드
     * @type {string}
     */
    rltdPdgrCd: string

    /** 관련상품템플릿코드
     * @type {string}
     */
    rltdPdtmCd: string

    /** 관련상품코드
     * @type {string}
     */
    rltdPdcd: string

    /** 관련상품명
     * @type {string}
     */
    rltdPdm: string

    /** 풀 상품코드
     * @type {string}
     */
    allPdcd?: string

    /** 상품비고내용
     * @type {string}
     */
    pdfRmrkCon?: string
}

export const initialState: comboProduct = {
    rltdPdlnCd: '',
    rltdPdgrCd: '',
    rltdPdtmCd: '',
    rltdPdcd: '',
    rltdPdm: '',
    nofcRlncPgrsScd02: '',
    nofcCmbTcd: '',
    nofcCmbType: '',
    nofcCmbPgrsYn: '',
    nfchPrcfGrpCd: '',
    nfchPrcfGrpCdNm: '',
    allPdcd: '',
    pdfRmrkCon: '',
}
